<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Location Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`Update ${customer_location.customer.full_name}`"
      class="mb-3"
    >
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Location Actions">
          <b-button
            variant="success"
            class="ml-1 text-white"
            :to="`/customer/${customer_location.customer_id}`"
          >
            <i class="fal fa-arrow-left" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit customer contact'">
      <template #gated-content>
        <customer-location-form
          :customer_location="customer_location"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import CustomerLocationForm from "@/components/crm/customerlocation/form/CustomerLocationForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { CrmRepositoryFactory } from "@/repositories/crm/CrmRepositoryFactory";
import { customerLocationNotifications } from "@/shared/notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { getModel } from "@/shared/fetch-utils";

const CustomerLocationsRepository =
  CrmRepositoryFactory.get("customerLocations");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "CustomerLocationEdit",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerLocationForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      customer_location_id: this.$route.params.customer_location_id || null,
      customer_location: null,
    };
  },
  methods: {
    async submit(form_data) {
      try {
        await CustomerLocationsRepository.update(this.customer_location_id, {
          customer_id: this.customer_location.customer_id,
          ...form_data,
        });

        this.editSuccess();
        this.$router.push(`/customer/${this.customer_location.customer_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.customer_location = await getModel({
      model_type: "customer_location",
      id: this.customer_location_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: customerLocationNotifications,
};
</script>
